namespace $ {

	$mol_style_define( $bog_ui_app_table, {

		padding: $mol_gap.block,

		Description: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Selected_info: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '0.5rem',
				bottom: '0.75rem',
			},
		},

		Table: {
			flex: {
				shrink: 1,
			},
			overflow: {
				x: 'auto',
			},
			minWidth: 0,
		},

	} )

}
